/* Calisthenics Africa — theme behaviour.
   Ported from website/redesign-2026-09/assets/js/store.js, with the mockup's fake cart
   replaced by Shopify's cart AJAX API. Everything is progressive enhancement: every
   control works as a plain link or form post without JavaScript. */
(function () {
  'use strict';

  /* ---------- Cart ---------- */

  function setCount(n) {
    document.querySelectorAll('[data-ca-cart-count]').forEach(function (el) {
      el.textContent = String(n);
      el.classList.add('ca-is-bumped');
      setTimeout(function () { el.classList.remove('ca-is-bumped'); }, 200);
    });
    // The lander header's cart link waits for something to be in the cart, then appears
    // without a reload (sections/ca-lander-header.liquid). Landers have no other way to it.
    document.querySelectorAll('[data-ca-cart-link]').forEach(function (el) { el.hidden = !(n > 0); });
    document.querySelectorAll('[data-ca-cart-host]').forEach(function (el) { el.classList.toggle('ca-has-cart', n > 0); });
  }

  function countNow() {
    var el = document.querySelector('[data-ca-cart-count]');
    return el ? parseInt(el.textContent, 10) || 0 : 0;
  }

  function refreshHorizonCart() {
    // Let Horizon's own cart components know something changed, without depending on them.
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true }));
  }

  /* ---------- Added to cart (snippets/ca-added-to-cart.liquid) ----------
       The primary feedback for every Add to cart: what went in, at what price, Check out or
       Keep looking. Not modal, because a sheet the customer has to fight is worse than no
       sheet: Keep looking, Escape or a tap anywhere else closes it. */

  var sheet = document.querySelector('[data-ca-added]');
  var sheetFrom = null;   // the button that opened it, so focus can go back there

  // "R1,745" — the same format as snippets/ca-money.liquid.
  function money(cents) {
    var whole = Math.floor(cents / 100), part = cents % 100;
    return 'R' + String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, ',') + (part ? '.' + (part < 10 ? '0' : '') + part : '');
  }

  function openSheet(item, button) {
    if (!sheet || !item) return;
    var cents = item.final_price != null ? item.final_price : item.price;
    sheet.querySelector('[data-ca-added-name]').textContent = item.product_title || item.title || '';
    sheet.querySelector('[data-ca-added-price]').textContent = typeof cents === 'number' ? money(cents) : '';
    sheetFrom = button;
    sheet.hidden = false;
    document.documentElement.classList.add('ca-added-open');
    sheet.focus({ preventScroll: true });
  }

  function closeSheet() {
    if (!sheet || sheet.hidden) return;
    var hadFocus = sheet.contains(document.activeElement);
    sheet.hidden = true;
    document.documentElement.classList.remove('ca-added-open');
    if (hadFocus && sheetFrom && document.contains(sheetFrom)) sheetFrom.focus({ preventScroll: true });
    sheetFrom = null;
  }

  if (sheet) {
    sheet.querySelectorAll('[data-ca-added-close]').forEach(function (b) { b.addEventListener('click', closeSheet); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSheet(); });
    // A tap anywhere else is keeping on looking too. Another Add to cart refills the sheet instead.
    document.addEventListener('click', function (e) {
      if (sheet.hidden || sheet.contains(e.target) || e.target.closest('[data-ca-add]')) return;
      closeSheet();
    });
  }

  // Back from the cart. Pages here are not no-store, so the browser can restore this one exactly
  // as it was left: sheet open, count as it was. Whoever comes back is keeping on looking, and may
  // have changed the cart in the meantime, so close the sheet and ask the cart again.
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    closeSheet();
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { setCount(cart.item_count); })
      .catch(function () {});
  });

  function addToCart(button) {
    var id = button.getAttribute('data-variant-id');
    if (!id) return;
    var label = button.textContent;
    button.setAttribute('aria-busy', 'true');
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
      .then(function (res) {
        button.removeAttribute('aria-busy');
        if (!res.ok) throw new Error((res.body && res.body.description) || 'Could not add to cart');
        button.textContent = 'Added to cart';
        button.classList.add('ca-is-added');
        setTimeout(function () { button.textContent = label; button.classList.remove('ca-is-added'); }, 1600);
        openSheet(res.body && (res.body.items ? res.body.items[0] : res.body), button);
        // The count, and with it the lander's cart link. The add has already gone through,
        // so if /cart.js fails the link must still appear rather than strand the customer.
        fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) { setCount(cart.item_count); }, function () { setCount(countNow() + 1); })
          .then(refreshHorizonCart);
      })
      .catch(function (err) {
        button.removeAttribute('aria-busy');
        button.textContent = label;
        var note = button.parentElement && button.parentElement.querySelector('.ca-form-error');
        if (!note) {
          note = document.createElement('p');
          note.className = 'ca-form-error';
          if (button.parentElement) button.parentElement.appendChild(note);
        }
        note.textContent = err.message;
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ca-add]');
    if (!btn) return;
    e.preventDefault();
    addToCart(btn);
  });

  /* Show either the buy state or the out-of-stock state, never both. Liquid sets the
     opening state from `product.available`; this only runs when a weight selector changes
     it. `data-ca-buy-swap` is the Add to cart button, `data-ca-out-swap` the notify form
     on the buy box and the links to it from the hero, the final CTA and the sticky bar. */
  function setBuyState(available, variantId) {
    document.querySelectorAll('[data-ca-buy-swap]').forEach(function (b) { b.hidden = !available; });
    document.querySelectorAll('[data-ca-out-swap]').forEach(function (el) {
      el.hidden = available;
      if (!available && variantId && el.hasAttribute('data-ca-notify')) {
        // Pointing at a different weight means a different subscription, so ask again.
        el.setAttribute('data-ca-variant', variantId);
        resetNotify(el);
      }
    });
  }

  /* ---------- Product gallery: thumbnail picks the large image (desktop);
       on mobile the track is a plain swipe strip and needs no script. ---------- */

  document.querySelectorAll('[data-ca-gallery]').forEach(function (g) {
    var slides = g.querySelectorAll('.ca-gallery__slide');
    var thumbs = g.querySelectorAll('.ca-gallery__thumbs button');
    thumbs.forEach(function (b, i) {
      b.addEventListener('click', function () {
        slides.forEach(function (s, j) { s.classList.toggle('ca-is-active', i === j); });
        thumbs.forEach(function (t, j) { t.classList.toggle('ca-is-active', i === j); });
      });
    });
  });

  /* ---------- Weight selectors that drive price, name, cutout and Add to cart ----------
       On product pages the pills are plain links to the sibling products and carry no
       data-ca-price, so this does nothing to them. */

  document.querySelectorAll('[data-ca-wsel]').forEach(function (w) {
    w.querySelectorAll('.ca-wsel__opt').forEach(function (o) {
      o.addEventListener('click', function (e) {
        if (!o.dataset.caPrice) return;
        e.preventDefault();
        document.querySelectorAll('[data-ca-price-out]').forEach(function (el) { el.textContent = o.dataset.caPrice; });
        document.querySelectorAll('[data-ca-name-out]').forEach(function (el) { el.textContent = o.dataset.caName; });
        document.querySelectorAll('[data-ca-kg-out]').forEach(function (el) { el.textContent = o.dataset.caKg; });
        if (o.dataset.caVariant) {
          // Quick-add buttons on product cards sell their own product — a lander that
          // carries both a weight selector and a product grid must not retarget them.
          document.querySelectorAll('[data-ca-add]:not(.ca-card__cta)').forEach(function (b) { b.setAttribute('data-variant-id', o.dataset.caVariant); });
          // A weight with no stock must never leave a live Add to cart on the page: the
          // button hides and the notify form (or the link down to it) takes its place.
          setBuyState(o.dataset.caAvailable !== 'false', o.dataset.caVariant);
        }
        if (o.dataset.caImgSrc) {
          document.querySelectorAll('.ca-hero-q__img, .ca-buybox__media img').forEach(function (im) {
            im.src = o.dataset.caImgSrc;
            if (o.dataset.caImgSrcset) im.srcset = o.dataset.caImgSrcset;
          });
        }
        // keep every weight selector on the page in step
        document.querySelectorAll('.ca-wsel__opt[data-ca-name]').forEach(function (x) {
          x.classList.toggle('ca-is-selected', x.dataset.caName === o.dataset.caName);
        });
      });
    });
  });

  /* ---------- Review feed: filter by weight, reveal in pages.
       Without JS every review is simply visible. ---------- */

  document.querySelectorAll('[data-ca-rv-list]').forEach(function (list) {
    var scope = list.closest('section') || document;
    var items = Array.prototype.slice.call(list.querySelectorAll('.ca-review'));
    var chips = scope.querySelectorAll('[data-ca-rv-filter]');
    var more = scope.querySelector('[data-ca-rv-more]');
    var count = scope.querySelector('[data-ca-rv-count]');
    if (!more) return;
    var PAGE = 6, STEP = 8, shown = PAGE, filter = 'all';
    function render() {
      var vis = items.filter(function (it) { return filter === 'all' || it.dataset.caKg === filter; });
      items.forEach(function (it) { it.classList.add('ca-is-hidden'); });
      vis.slice(0, shown).forEach(function (it) { it.classList.remove('ca-is-hidden'); });
      var rest = vis.length - Math.min(shown, vis.length);
      more.hidden = rest <= 0;
      more.textContent = 'Show ' + Math.min(rest, STEP) + ' more';
      if (count) count.textContent = 'Showing ' + Math.min(shown, vis.length) + ' of ' + vis.length;
    }
    chips.forEach(function (c) {
      c.addEventListener('click', function () {
        filter = c.dataset.caRvFilter;
        shown = PAGE;
        chips.forEach(function (x) { x.classList.toggle('ca-is-on', x === c); });
        render();
      });
    });
    more.addEventListener('click', function () { shown += STEP; render(); });
    render();
  });

  /* ---------- "Notify me" → Klaviyo back in stock ----------
       Markup: snippets/ca-notify-form.liquid, rendered wherever a product has no stock.
       Posts to Klaviyo's public client endpoint with the public site ID, so no secret is
       in the page. Klaviyo's Shopify integration resolves the variant id, and the Back in
       Stock flow sends the one email once Shopify reports stock again.

       Without JavaScript the form still renders and says what it is; it just can't post,
       which is the same trade the pop-up and the newsletter make. ---------- */

  function resetNotify(box) {
    var form = box.querySelector('[data-ca-notify-form]');
    var done = box.querySelector('[data-ca-notify-done]');
    var err = box.querySelector('[data-ca-notify-error]');
    if (form) { form.hidden = false; form.reset(); }
    if (done) done.hidden = true;
    if (err) { err.hidden = true; err.textContent = ''; }
  }

  document.querySelectorAll('[data-ca-notify]').forEach(function (box) {
    var form = box.querySelector('[data-ca-notify-form]');
    var done = box.querySelector('[data-ca-notify-done]');
    var err = box.querySelector('[data-ca-notify-error]');
    if (!form) return;

    function fail(message) {
      if (!err) return;
      err.textContent = message;
      err.hidden = false;
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (err) { err.hidden = true; err.textContent = ''; }
      var field = form.querySelector('input[type="email"]');
      var email = field.value.trim();
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) return fail('That email address doesn\u2019t look right.');
      var variant = box.getAttribute('data-ca-variant');
      if (!variant) return fail('That didn\u2019t go through. Try again in a moment.');
      var btn = form.querySelector('button[type="submit"]');
      btn.setAttribute('aria-busy', 'true');
      fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(box.dataset.caCompany), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: '2026-04-15' },
        body: JSON.stringify({
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              channels: ['EMAIL'],
              profile: { data: { type: 'profile', attributes: { email: email } } }
            },
            relationships: {
              variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variant } }
            }
          }
        })
      })
        .then(function (r) {
          btn.removeAttribute('aria-busy');
          if (!r.ok) return fail('That didn\u2019t go through. Try again in a moment.');
          form.hidden = true;
          if (done) done.hidden = false;
        })
        .catch(function () {
          btn.removeAttribute('aria-busy');
          fail('That didn\u2019t go through. Try again in a moment.');
        });
    });
  });

  /* ---------- Newsletter → Klaviyo (public client endpoint, no secret in the page) ---------- */

  document.querySelectorAll('[data-ca-klaviyo]').forEach(function (form) {
    var msg = form.querySelector('[data-ca-klaviyo-msg]');
    var idle = msg ? msg.textContent : '';
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = form.querySelector('input[type="email"]').value.trim();
      if (!email) return;
      var btn = form.querySelector('button[type="submit"]');
      btn.setAttribute('aria-busy', 'true');
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(form.dataset.companyId), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: '2026-04-15' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: { profile: { data: { type: 'profile', attributes: { email: email } } } },
            relationships: { list: { data: { type: 'list', id: form.dataset.listId } } }
          }
        })
      })
        .then(function (r) {
          btn.removeAttribute('aria-busy');
          if (msg) msg.textContent = r.ok ? "You're on the list." : 'That didn’t go through. Try again in a moment.';
          if (r.ok) form.reset();
        })
        .catch(function () {
          btn.removeAttribute('aria-busy');
          if (msg) msg.textContent = 'That didn’t go through. Try again in a moment.';
          setTimeout(function () { if (msg) msg.textContent = idle; }, 6000);
        });
    });
  });
})();

/* ---------- WhatsApp button (snippets/ca-whatsapp-button.liquid) ----------
   It floats bottom-right on every page and must never sit on something a customer is
   trying to tap. So it rides above the sticky buy bar, hides while the pop-up or the Added
   to cart sheet is open (CSS) or a field has focus on a phone, and steps aside whenever a
   control passes underneath it: a button, a field, the notify form, or a link drawn as a control (its own
   fill or border, like the weight pills). Links that aren't — product cards, the footer —
   don't count; they stay tappable around it. tools/viewport-check.mjs checks the same rule. */
(function () {
  'use strict';

  var btn = document.querySelector('[data-ca-wa]');
  if (!btn) return;
  var root = document.documentElement;
  var TAPPABLE = '.ca-sticky-cta, .ca-notify, .ca-popup__card, .ca-btn, button, input, select, textarea, [role="button"], a[href], label';
  var CLEAR = /rgba\(0, 0, 0, 0\)|transparent/;

  // A link or label counts only when it is drawn as a control, with no photo in it.
  function control(el) {
    if (!el.matches('a[href], label') || el.matches('.ca-btn')) return true;
    if (el.querySelector('img, picture, video')) return false;
    var cs = getComputedStyle(el);
    return !CLEAR.test(cs.backgroundColor) || (parseFloat(cs.borderTopWidth) > 0 && !CLEAR.test(cs.borderTopColor));
  }

  // The sticky buy bar is fixed to the bottom on phones. Sit 12px above whatever height it is.
  function lift() {
    var bar = document.querySelector('.ca-sticky-cta');
    if (!bar) return 0;
    var r = bar.getBoundingClientRect();
    return r.height > 0 && r.top < window.innerHeight ? Math.ceil(window.innerHeight - r.top) : 0;
  }

  // Any control whose box overlaps the button's box. The same test the viewport check makes:
  // sampling a few points missed a notify form that only clipped the button's edge.
  function covering() {
    var r = btn.getBoundingClientRect();
    var els = document.querySelectorAll(TAPPABLE);
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el === btn || btn.contains(el)) continue;
      var b = el.getBoundingClientRect();
      if (b.width < 1 || b.height < 1 || b.bottom <= r.top || b.top >= r.bottom || b.right <= r.left || b.left >= r.right) continue;
      if (el.checkVisibility && !el.checkVisibility({ opacityProperty: true, visibilityProperty: true })) continue;
      if (control(el)) return true;
    }
    return false;
  }

  var queued = false;
  function update() {
    queued = false;
    var h = lift();
    btn.style.bottom = h ? h + 12 + 'px' : '';
    btn.classList.toggle('ca-wa--aside', covering());
  }
  function queue() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(update);
  }

  window.addEventListener('scroll', queue, { passive: true });
  window.addEventListener('resize', queue);
  window.addEventListener('load', queue);
  document.addEventListener('click', function () { setTimeout(queue, 60); });
  document.addEventListener('focusin', function (e) {
    var t = e.target;
    if (t.matches && t.matches('input:not([type="checkbox"]):not([type="radio"]):not([type="submit"]):not([type="button"]), textarea, select, [contenteditable="true"]')) root.classList.add('ca-typing');
  });
  document.addEventListener('focusout', function () { root.classList.remove('ca-typing'); queue(); });
  update();
})();

/* ---------- Signup pop-up (lead capture) ----------
   Markup: snippets/ca-signup-popup.liquid. Posts to Klaviyo's public client endpoints with
   the public site ID, so no secret is in the page. Step 1 subscribes the email to the Email
   List (single opt-in). Step 2 stores the WhatsApp number and its consent as profile
   properties — nothing is ever sent on WhatsApp from here.
   `?ca_popup=1` forces it open at once (preview and the viewport check); `?ca_popup=0` hides it. */
(function () {
  'use strict';

  var root = document.querySelector('[data-ca-popup]');
  if (!root) return;

  var params = new URLSearchParams(window.location.search);
  if (params.get('ca_popup') === '0') return;
  var forced = params.get('ca_popup') === '1';
  if (root.dataset.caEnabled !== 'true' && !forced) return;
  if (!forced && /^\/(cart|checkouts?|account|customers)(\/|$)/.test(window.location.pathname)) return;

  var KEY = 'ca_popup_state';
  var DISMISS_DAYS = 21;

  function readState() {
    try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch (e) { return {}; }
  }
  function writeState(patch) {
    try {
      var s = readState();
      for (var k in patch) { if (Object.prototype.hasOwnProperty.call(patch, k)) s[k] = patch[k]; }
      localStorage.setItem(KEY, JSON.stringify(s));
    } catch (e) { /* private mode: the pop-up just shows again next visit */ }
  }

  var state = readState();
  if (!forced && state.done) return;
  if (!forced && state.dismissedAt && Date.now() - state.dismissedAt < DISMISS_DAYS * 864e5) return;

  var card = root.querySelector('.ca-popup__card');
  var steps = {};
  root.querySelectorAll('[data-ca-step]').forEach(function (el) { steps[el.dataset.caStep] = el; });
  var emailForm = root.querySelector('[data-ca-popup-email]');
  var waForm = root.querySelector('[data-ca-popup-whatsapp]');
  var opened = false;
  var lastFocus = null;
  var email = '';

  function show(name) {
    Object.keys(steps).forEach(function (k) { steps[k].hidden = k !== name; });
    var focusable = steps[name].querySelector('input, button');
    if (focusable && name !== 'email') focusable.focus();
  }

  // Someone with something in the cart has already decided, which is not who this was built
  // for, and it would land on top of the Added to cart sheet (Mike, 2026-09-23). Read when it
  // is about to open, not when it is armed: the cart can fill while the timer runs.
  function cartHasItems() {
    var counts = document.querySelectorAll('[data-ca-cart-count]');
    for (var i = 0; i < counts.length; i++) if ((parseInt(counts[i].textContent, 10) || 0) > 0) return true;
    return false;
  }

  function open() {
    if (opened) return;
    if (!forced && cartHasItems()) return;
    opened = true;
    lastFocus = document.activeElement;
    root.hidden = false;
    document.documentElement.classList.add('ca-popup-open');
    if (card) card.focus();
  }

  function close(reason) {
    if (!opened) return;
    opened = false;
    root.hidden = true;
    document.documentElement.classList.remove('ca-popup-open');
    if (reason === 'dismissed') writeState({ dismissedAt: Date.now() });
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function fail(form, message) {
    var box = form.querySelector('[data-ca-popup-error]');
    if (!box) return;
    box.textContent = message;
    box.hidden = false;
  }
  function clearFail(form) {
    var box = form.querySelector('[data-ca-popup-error]');
    if (box) { box.hidden = true; box.textContent = ''; }
  }

  function klaviyo(pathname, body) {
    return fetch('https://a.klaviyo.com/client/' + pathname + '/?company_id=' + encodeURIComponent(root.dataset.caCompany), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: '2026-04-15' },
      body: JSON.stringify(body)
    });
  }

  /* South African mobile numbers, however they are typed: 082…, 27 82…, +2782…, with or
     without spaces. Anything else is refused rather than stored wrong. */
  function toE164(raw) {
    var digits = String(raw).replace(/[^\d+]/g, '');
    if (digits.indexOf('+') > 0) digits = digits.replace(/\+/g, '');
    if (digits.charAt(0) === '0') digits = '+27' + digits.slice(1);
    else if (digits.slice(0, 3) === '+27') digits = '+27' + digits.slice(3);
    else if (digits.slice(0, 2) === '27') digits = '+27' + digits.slice(2);
    else if (digits.charAt(0) !== '+') digits = '+27' + digits;
    return /^\+27[6-8]\d{8}$/.test(digits) ? digits : '';
  }

  function textOf(selector) {
    var el = root.querySelector(selector);
    return el ? el.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  emailForm.addEventListener('submit', function (e) {
    e.preventDefault();
    clearFail(emailForm);
    var field = emailForm.querySelector('input[type="email"]');
    var value = field.value.trim();
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(value)) return fail(emailForm, 'That email address doesn’t look right.');
    var btn = emailForm.querySelector('button[type="submit"]');
    btn.setAttribute('aria-busy', 'true');
    klaviyo('subscriptions', {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Website pop-up',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: value,
                properties: {
                  ca_signup_source: 'Website pop-up',
                  ca_signup_page: window.location.pathname,
                  ca_email_consent_text: textOf('.ca-popup__fine')
                },
                subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
              }
            }
          }
        },
        relationships: { list: { data: { type: 'list', id: root.dataset.caList } } }
      }
    })
      .then(function (r) {
        btn.removeAttribute('aria-busy');
        if (!r.ok) return fail(emailForm, 'That didn’t go through. Try again in a moment.');
        email = value;
        state.done = true;
        writeState({ done: true, at: Date.now() });
        show('whatsapp');
      })
      .catch(function () {
        btn.removeAttribute('aria-busy');
        fail(emailForm, 'That didn’t go through. Try again in a moment.');
      });
  });

  waForm.addEventListener('submit', function (e) {
    e.preventDefault();
    clearFail(waForm);
    var phone = waForm.querySelector('input[type="tel"]');
    var number = toE164(phone.value);
    if (!number) return fail(waForm, 'That doesn’t look like a South African mobile number.');
    var btn = waForm.querySelector('button[type="submit"]');
    btn.setAttribute('aria-busy', 'true');
    klaviyo('profiles', {
      data: {
        type: 'profile',
        attributes: {
          email: email,
          properties: {
            whatsapp_opt_in: true,
            whatsapp_number: number,
            whatsapp_opt_in_at: new Date().toISOString(),
            whatsapp_opt_in_source: 'Website pop-up — ' + window.location.pathname,
            whatsapp_consent_text: textOf('[data-ca-wa-consent]')
          }
        }
      }
    })
      .then(function (r) {
        btn.removeAttribute('aria-busy');
        if (!r.ok) return fail(waForm, 'That didn’t go through. Try again in a moment.');
        show('done');
      })
      .catch(function () {
        btn.removeAttribute('aria-busy');
        fail(waForm, 'That didn’t go through. Try again in a moment.');
      });
  });

  root.querySelector('[data-ca-popup-skip]').addEventListener('click', function () { show('done'); });

  root.querySelectorAll('[data-ca-popup-close]').forEach(function (el) {
    el.addEventListener('click', function () { close(state.done ? 'done' : 'dismissed'); });
  });

  document.addEventListener('keydown', function (e) {
    if (!opened) return;
    if (e.key === 'Escape') return close('dismissed');
    if (e.key !== 'Tab') return;
    var items = Array.prototype.filter.call(
      card.querySelectorAll('a[href], button, input:not([type="hidden"])'),
      function (el) { return el.offsetParent !== null; }
    );
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* When to show it: to someone leaving or hesitating, not to someone on the way to buying.
     Desktop gets exit intent. Phones have no cursor to leave with, so the nearest signal is
     leaving the page and coming back (another app or tab, often to compare a price): after a
     minute here, it opens on their return. Everyone else gets it after two minutes, and never
     with something in the cart (open() checks).
     Until 2026-10-01 phones got it at 45s or 65% of the page (25s or half before 2026-09-23).
     On a long lander 65% is the buy box, so it landed on people at the moment they decided:
     two of the three FIRST150 orders came within 25 minutes of landing, one in five. Mike
     asked for the call to be made on the numbers; CA-THEME-NOTES.md, Signup pop-up. */
  function arm() {
    var phone = window.matchMedia('(max-width: 899px)').matches;
    var armedAt = Date.now();
    setTimeout(open, 120000);
    if (phone) {
      var hiddenAt = 0;
      document.addEventListener('visibilitychange', function () {
        if (document.visibilityState === 'hidden') { hiddenAt = Date.now(); return; }
        if (hiddenAt && Date.now() - hiddenAt > 3000 && Date.now() - armedAt > 60000) open();
      });
    } else {
      document.addEventListener('mouseout', function (e) {
        if (e.clientY <= 0 && !e.relatedTarget && Date.now() - armedAt > 8000) open();
      });
    }
  }

  if (forced) {
    // ?ca_popup_step=whatsapp|done opens straight on a later step, so every step can be
    // checked at all eight sizes (tools/viewport-check.json) without a real signup.
    var step = params.get('ca_popup_step');
    if (step && steps[step]) show(step);
    open();
  } else if (window.klaviyo && typeof window.klaviyo.isIdentified === 'function') {
    // Someone Klaviyo already knows is on our list; don't interrupt them.
    Promise.race([
      window.klaviyo.isIdentified(),
      new Promise(function (resolve) { setTimeout(function () { resolve(false); }, 2500); })
    ]).then(function (known) { if (!known) arm(); }).catch(arm);
  } else {
    arm();
  }
})();
